'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppHeaderContainer = exports.AppHeader = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _user = require('redux/saga/selectors/user');

var _selectors = require('redux/saga/selectors');

var _request = require('redux/saga/selectors/request');

var _bound = require('redux/saga/entities/bound');

var _Header = require('components/Header/Header');

var _HeaderUserDetails = require('components/Header/HeaderUserDetails');

var _PortalDestination = require('components/Portal/PortalDestination');

var _Media = require('decorators/Media/Media');

var _Media2 = _interopRequireDefault(_Media);

var _deep = require('helpers/deep');

var _video = require('constants/video');

var _go = require('constants/go');

var _memberStatus = require('enums/memberStatus');

var _SearchBoxContainer = require('features/Search/SearchBox/SearchBoxContainer');

var _Search = require('features/Search/Search.helpers');

var _Search2 = require('features/Search/Search.route');

var _decorator = require('helpers/decorator');

var _Search3 = require('features/Search/Search.constants');

var _NavigationCta = require('./NavigationCta');

var _DesktopUserDropdown = require('./DesktopUserDropdown');

var _Navigation = require('./Navigation');

var _CreditCount = require('./NavItems/CreditCount');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, props) {
  var permissions = _bound.userPermissions.data(state) || {};
  var memberStatus = (0, _user.memberStatus)(state);
  var isOnZeroClassPlan = permissions.free_subscription_plan;
  var canViewUnifiedSearch = permissions[_Search3.SEARCH_ACCESS_PERMISSION];
  var path = (0, _request.pathSelector)(state);
  var isLivePage = _video.CP_LIVE_URL_REGEX.test(path);
  var isGoPage = _go.CP_GO_URL_REGEX.test(path);
  var isSearchPage = path.indexOf(_Search2.PATH) === 0;
  // `isExplorePage` can be removed once Optimizely testing of Explore v. unified
  // search is completed, along with all traces of "_optimizely_search_test"
  var isExplorePage = path.indexOf('/explore') === 0;

  return {
    canViewUnifiedSearch: canViewUnifiedSearch,
    creditsRemaining: (0, _deep.deepExtract)('credits_remaining', _bound.userCreditBalance.data(state, (0, _selectors.scheduleContext)(state)), 0),
    isDark: state.page.darkNav,
    isGoPage: isGoPage,
    isLivePage: isLivePage,
    isSearchPage: isSearchPage,
    isExplorePage: isExplorePage,
    isLoggedIn: (0, _user.isLoggedIn)(state),
    isMinimal: state.page.reducedNav,
    isTransparentWhenAtScrollTop: state.page.sellHeader,
    memberStatus: memberStatus,
    path: (0, _request.pathSelector)(state),
    permissions: permissions,
    showCreditCount: !isOnZeroClassPlan && (0, _memberStatus.memberStatus)('ACTIVE', memberStatus),
    showCta: !state.page.sellHeader && !isLivePage,
    showSearchBox: props.mediaQueryLg && ((0, _Search.selectHasAccessToSearch)(state) || isSearchPage),
    user: _bound.userProfile.data(state)
  };
};

var AppHeader = exports.AppHeader = function (_Component) {
  (0, _inherits3.default)(AppHeader, _Component);

  function AppHeader() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, AppHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = AppHeader.__proto__ || (0, _getPrototypeOf2.default)(AppHeader)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      dropdownExpanded: false
    }, _this2.handleDropdownStateToggled = function () {
      return _this.setState(function (state) {
        return { dropdownExpanded: !state.dropdownExpanded };
      });
    }, _this2.handleNavigation = function () {
      return _this.setState({ dropdownExpanded: false });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(AppHeader, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.path !== nextProps.path) {
        this.handleNavigation();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isTransparentWhenAtScrollTop = _props.isTransparentWhenAtScrollTop,
          canViewUnifiedSearch = _props.canViewUnifiedSearch,
          creditsRemaining = _props.creditsRemaining,
          showCreditCount = _props.showCreditCount,
          showSearchBox = _props.showSearchBox,
          mediaQueryLg = _props.mediaQueryLg,
          memberStatus = _props.memberStatus,
          permissions = _props.permissions,
          isDark = _props.isDark,
          isLoggedIn = _props.isLoggedIn,
          isLivePage = _props.isLivePage,
          isSearchPage = _props.isSearchPage,
          isExplorePage = _props.isExplorePage,
          isGoPage = _props.isGoPage,
          isMinimal = _props.isMinimal,
          showCta = _props.showCta,
          user = _props.user;
      var dropdownExpanded = this.state.dropdownExpanded;


      var navigationProps = {
        user: user,
        permissions: permissions,
        isLivePage: isLivePage,
        isGoPage: isGoPage,
        isActiveUser: (0, _memberStatus.memberStatus)('ACTIVE', memberStatus),
        isUnpaidUser: (0, _memberStatus.memberStatus)('UNPAID', memberStatus),
        isCancelledUser: (0, _memberStatus.memberStatus)('CANCELLED', memberStatus),
        isUnsubscribedUser: (0, _memberStatus.memberStatus)('UNSUBSCRIBED', memberStatus),
        isLoggedIn: isLoggedIn,
        isMinimal: isMinimal,
        isSearchPage: isSearchPage
      };

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _Header.Header,
          {
            isDark: isDark,
            isTransparentWhenAtScrollTop: isTransparentWhenAtScrollTop,
            onDropdownStateToggled: this.handleDropdownStateToggled,
            dropdownOpen: dropdownExpanded,
            showHamburger: !memberStatus,
            isMobile: !mediaQueryLg
          },
          showSearchBox && _react2.default.createElement(_SearchBoxContainer.SearchBoxContainer, null),
          _react2.default.createElement('div', { className: 'header__spacer' }),
          !isMinimal && mediaQueryLg && _react2.default.createElement(_Navigation.Navigation, navigationProps),
          !isMinimal && showCta && _react2.default.createElement(_NavigationCta.NavigationCta, (0, _extends3.default)({
            className: isExplorePage || isSearchPage ? '_optimizely_search_test' : ''
          }, navigationProps)),
          _react2.default.createElement(_PortalDestination.PortalDestination, { id: 'nav-cta' }),
          showCreditCount && _react2.default.createElement(_CreditCount.CreditCount, { creditsRemaining: creditsRemaining }),
          memberStatus && _react2.default.createElement(
            _HeaderUserDetails.HeaderUserDetails,
            {
              firstName: user.first_name,
              mediaQueryLg: mediaQueryLg,
              dropdownOpen: dropdownExpanded,
              onDropdownStateToggled: this.handleDropdownStateToggled
            },
            _react2.default.createElement(_DesktopUserDropdown.DesktopUserDropdown, {
              canViewUnifiedSearch: canViewUnifiedSearch
            })
          )
        ),
        dropdownExpanded && !mediaQueryLg && _react2.default.createElement(_Navigation.Navigation, (0, _extends3.default)({}, navigationProps, {
          onClick: this.handleNavigation,
          isMobile: true,
          canViewUnifiedSearch: canViewUnifiedSearch
        }))
      );
    }
  }]);
  return AppHeader;
}(_react.Component);

AppHeader.propTypes = {
  canViewUnifiedSearch: _propTypes2.default.bool,
  creditsRemaining: _propTypes2.default.number,
  isDark: _propTypes2.default.bool,
  isGoPage: _propTypes2.default.bool,
  isLivePage: _propTypes2.default.bool,
  isSearchPage: _propTypes2.default.bool,
  isExplorePage: _propTypes2.default.bool,
  isLoggedIn: _propTypes2.default.bool,
  isMinimal: _propTypes2.default.bool,
  isTransparentWhenAtScrollTop: _propTypes2.default.bool,
  mediaQueryLg: _propTypes2.default.bool,
  memberStatus: _propTypes2.default.string,
  path: _propTypes2.default.string.isRequired,
  permissions: _propTypes2.default.object.isRequired,
  showCreditCount: _propTypes2.default.bool,
  showCta: _propTypes2.default.bool,
  showSearchBox: _propTypes2.default.bool,
  user: _propTypes2.default.object
};

var AppHeaderContainer = exports.AppHeaderContainer = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps), _Media2.default)(AppHeader);